import type { Virtualizer } from "@tanstack/react-virtual";

/**
 * Whether row `index` already shows whole between the scroll paddings (the
 * sticky header and totals rows), judged from the virtualizer's cached offset,
 * size, and measurements. `scrollToIndex` with `align: "auto"` moves nothing
 * then, yet still reads `scrollHeight` (a forced layout) and writes the
 * offset back with a reconcile loop over the next frames; skip it.
 */
export const isRowInView = (
    virtualizer: Virtualizer<HTMLDivElement, Element>,
    index: number,
) => {
    const item = virtualizer.measurementsCache[index];
    const offset = virtualizer.scrollOffset;
    const height = virtualizer.scrollRect?.height;
    if (item === undefined || offset === null || !height) {
        return false;
    }
    const { scrollPaddingStart, scrollPaddingEnd } = virtualizer.options;
    return (
        Math.max(item.start - scrollPaddingStart, 0) >= offset &&
        item.end + scrollPaddingEnd < offset + height
    );
};
